import { useLinked } from "@type-r/react"
import { Button, Flex, navigate, PrimaryButton } from "lqx-react/src"
import React from "react"
import { Connection } from "../api/connection"
import { ButtonsBlock, StatusDialog } from "../components/item-card-styles"
import { preventDefaultAndStopPropagation } from "../shared"

export const ConnectionsActions = ({ connection }: { connection: Connection }) => {
    const toggleConectionStatus = async () => {
        await connection.switchStatus()
    }

    const ConnectionStatusToggleButton = ({ onClick }) => {
        if (connection) {
            const $isOpen = useLinked(false);
            const btnColor = connection.isActive ? "red" : "blue";
            const btnText = connection.isActive ? "Deactivate" : "Activate";
            const title = connection.isActive ? "Deactivate Connection" : "Activate Connection";
            const text = connection.isActive ?
                "Are you sure you want to Deactivate this connection? Once Deactivated, the connection will stop operating" :
                "Are you sure you want to Activate this connection? Once activated, the connection will start operating";
            return <>
                <PrimaryButton
                    disabled={$isOpen.value}
                    onClick={(e) => { preventDefaultAndStopPropagation(e); $isOpen.set(true) }}
                    color={btnColor}>{btnText}
                </PrimaryButton>
                {$isOpen.value ? <StatusDialog $isOpen={$isOpen} onClick={onClick} text={text} title={title} /> : null}
            </>
        }
        else return <></>
    }

    return <>
        <ButtonsBlock>
            <Flex column justifyCenter>
                <ConnectionStatusToggleButton onClick={(e) => { preventDefaultAndStopPropagation(e); toggleConectionStatus() }}></ConnectionStatusToggleButton>
            </Flex>
            <Flex column justifyCenter>
                <Button onClick={() => navigate(`connections/edit/${connection.id}`)} color="primary">Edit</Button>
            </Flex>
        </ButtonsBlock>
    </>
};